import { useEffect, useState } from "react";
import { Alert } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";
import { useCXSignupDialog } from "@web-src/modules/cx/components/CXSignupDialog/useCXSignupDialog";
import { rateLimitEvents } from "./rateLimitEvents";

export const RateLimitHandler: React.FC = () => {
  const { t } = useTranslations();
  const cxSignupDialog = useCXSignupDialog();
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = rateLimitEvents.subscribe((type) => {
      if (type === "anonymous") {
        cxSignupDialog?.open({ forced: true });
        rateLimitEvents.reset();
      } else {
        setIsAlertOpen(true);
      }
    });
    return unsubscribe;
  }, [cxSignupDialog]);

  return (
    <Alert
      isOpen={isAlertOpen}
      disableBackdropClose
      title={t({
        id: "rate-limit.too-many-requests",
        defaultMessage: "Too Many Requests",
      })}
      content={t({
        id: "rate-limit.try-again-later",
        defaultMessage: "Please try again in a few minutes.",
      })}
      buttons={[
        {
          text: t({ id: "common.got-it", defaultMessage: "Got it" }),
          role: "close",
          onClick: () => {
            setIsAlertOpen(false);
            rateLimitEvents.reset();
          },
        },
      ]}
      onRequestClose={() => {
        setIsAlertOpen(false);
        rateLimitEvents.reset();
      }}
    />
  );
};
